export enum ModuleViews {
  Grid = 'grid',
  Register = 'register',
  Timeline = 'timeline',
  Workflow = 'workflow',
  Links = 'links',
}
